<section class="gallery-page">

    <div class="gallery-header">

        <h1>Lazzaro na terenu</h1>

        <p>
          Svaki tim ima svoj identitet, a svaka oprema svoju priču. U galeriji možete pogledati kako Lazzaro sportska oprema izgleda u upotrebi, istražiti različite kombinacije boja i dizajna, a zatim zajedno sa nama kreirati opremu koja će biti jedinstvena za vaš tim.
            Opremljeni kvalitetnim materijalima, dizajnom po vašoj meri, potpunom personalizacijom i pouzdanom isporukom.

        </p>

    </div>

    <div class="gallery-grid">

        <div
            class="gallery-item"
            *ngFor="let image of images; let i = index"
            (click)="open(i)">

            <img
                [src]="image.imageUrl"
                [alt]="image.title"
                loading="lazy">

        </div>

    </div>

</section>

<div
    class="lightbox"
    *ngIf="selectedIndex != -1">

    <button
        class="close"
        (click)="close()">

        ✕

    </button>

    <button
        class="prev"
        (click)="previous()">

        ‹

    </button>

    <img
        [src]="images[selectedIndex].imageUrl">

    <button
        class="next"
        (click)="next()">

        ›

    </button>

</div>